<template>
  <HeroEvent :data="page" />

  <Container indent="center" class="my-16">
    <AppLink
      v-if="page.link_external"
      class="w-fit text-md"
      show-link-arrow
      :to="page.link_external"
    >
      {{ page.link_external }}
    </AppLink>

    <ComponentsLoader
      v-else
      v-editor-target="'content'"
      :components="page.content"
    />

    <SocialShareIcons :alternates="page.alternates" class="mt-12 xs:mt-24" />
  </Container>

  <!-- SITE END REPLICATOR -->
  <ComponentsLoader
    v-if="page.event_site_end_replicator"
    v-editor-target="'event_site_end_replicator'"
    :components="page.event_site_end_replicator"
  />
</template>

<script setup>
provide('isEvent', true)

defineProps({
  page: { type: Object, required: true },
})
</script>
